import { useId } from "react";
import { SIGNUP_STATUS_LABELS } from "../../api";
import type { SignupStatus } from "../../api";
import { cx } from "../../components";
import styles from "./Esn.module.css";

/** Un statut, ou « toutes ». */
export type StatutInscriptions = SignupStatus | "toutes";

export type InscriptionsFiltresProps = {
  valeur: StatutInscriptions;
  onChange: (valeur: StatutInscriptions) => void;
};

/**
 * Filtre par statut, appliqué côté serveur : la file est relue à chaque
 * changement. Des radios, comme pour les feuilles : exclusives, au clavier,
 * annoncées comme un groupe.
 */
export function InscriptionsFiltres({ valeur, onChange }: InscriptionsFiltresProps) {
  const nom = useId();
  const options: { cle: StatutInscriptions; libelle: string }[] = [
    { cle: "pending", libelle: SIGNUP_STATUS_LABELS.pending },
    { cle: "accepted", libelle: SIGNUP_STATUS_LABELS.accepted + "s" },
    { cle: "rejected", libelle: SIGNUP_STATUS_LABELS.rejected + "s" },
    { cle: "toutes", libelle: "Toutes" },
  ];
  return (
    <fieldset className={styles.filtres}>
      <legend className={styles.legende}>Statut</legend>
      <div className={styles.choix}>
        {options.map((o) => (
          <label key={o.cle} className={cx(styles.puce, valeur === o.cle && styles.puceActive)}>
            <input
              type="radio"
              name={nom}
              value={o.cle}
              checked={valeur === o.cle}
              onChange={() => onChange(o.cle)}
              className="lde-visually-hidden"
            />
            <span>{o.libelle}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
